import { jsx as _jsx } from "react/jsx-runtime";
import { FormikSingleSelect } from "~/components/Formik/FormikSingleSelect";
import { IMAGE_SIZE_SINGLE_SELECT } from "~/constants/testIDs";
import { defaultImageSizeOptions } from "../../../ImageFormatFormField";
export const ExportImageSizeSelect = (param)=>{
    let { setIsEditing } = param;
    return /*#__PURE__*/ _jsx(FormikSingleSelect, {
        isSearchable: false,
        size: "extra-large",
        "data-testid": IMAGE_SIZE_SINGLE_SELECT,
        label: "Size *",
        name: "size",
        options: defaultImageSizeOptions,
        onOptionsClose: ()=>{
            setIsEditing(false);
        },
        onOptionsOpen: ()=>{
            setIsEditing(true);
        }
    });
};
